<template lang="pug">
	.tb(v-if="flat" :class="{'error': error}")
		label(v-if="label")
			| {{label}}
		.select-container
			slot
			span.error(v-if="error")
				| {{errorMessage}}
			span.arrow-down
	.dd(v-else :class="{'error': error}")
		label(v-if="label")
			| {{label}}
		.select-container
			slot
			span.arrow-down
		span.error(v-if="error")
			| {{errorMessage}}
</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	.dd
		margin-top: 10px
		.error
			color: chart-red
			margin-top: 5px
			display: block
		&.error
			select
				border-color: chart-red
		.select-container
			transition-all-four()
			box-shadow-dd()
			margin: 0 0 20px 0
			max-width: 240px
			border: 1px solid sfc-gray-dark
			background-color: #fff
			border-radius()
			position: relative
			padding: 0
			font-weight: body-font-weight
			font-size: body-font-size
			margin: 0
			display: block
			cursor: pointer
		select
			-webkit-appearance: none
			-moz-appearance: none
			appearance: none
			-webkit-box-shadow: none !important
			-moz-box-shadow: none !important
			box-shadow: none !important
			background-color: transparent
			border: 0
			cursor: pointer
			display: block
			width: 95%
			padding: 10px 15px
			position: relative
			z-index: 41
			option
				color: body-font-color

	.tb
		margin: 10px 0
		.select-container
			width: 100%
			margin-bottom: 0px
			select
				width: 100%
				background: transparent
				font-size: body-font-size-md
				z-index: 20
				position: relative
				padding-right: 25px
				text-overflow: ellipsis
				color: sfc-gray-dark
				option
					color: body-font-color
		span.arrow-down
			right: 0
			top: 18px
			border-left: 5px solid transparent;
			border-right: 5px solid transparent;
			border-top: 6px solid #000
			z-index: 15
		&:hover
			span.arrow-down
				border-top: 7px solid #000
		&.error
			select
				border-bottom-color: chart-red

</style>
<script>
export default {
	props: {
		errorMessage:{
			default: false
		},
		error:{
			default: false
		},
		value:{
			default: null
		},
		flat :{
			default: true
		},
		label:{
			default: null
		}
	},
	data() {
		return {
		}
	}
}
</script>
